import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';
import React from 'react';

export const Wrapper = styled('label', React.forwardRef)<{ $disabled: boolean }>`
    display: block;
    padding: 24px;
    border-radius: 12px;
    border: 1px solid ${COLORS.neutral_20};
    transition: all 0.3s ease;
    background-color: ${COLORS.neutral_00};

    ${({ $disabled }) =>
        $disabled
            ? `opacity: 0.5;`
            : `
        cursor: pointer;
        
        &:hover {
            background-color: ${COLORS.neutral_05};
        }
    
        &:active {
            background-color: ${COLORS.neutral_10};
        }
    `}
`;

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
`;

export const StyledInput = styled('input', React.forwardRef)`
    display: none;
`;
